<template>
    <q-page>
        <div class="q-display-1">Osiągnięcia</div>

        <ul>
            <li v-for="groupId in groups"
                :key="groupId">
                {{groupId}}

                <q-btn flat round icon="edit" @click="edit(groupId)"></q-btn>
            </li>
        </ul>

        <fixed-buttons>
            <q-btn
                flat
                style="font-size: 1.5rem" dense
                icon="add_circle"
                color="primary"
                to="/osiagniecia/dodaj">
                <q-tooltip anchor="top left">
                    Dodaj nowe
                </q-tooltip>
            </q-btn>
        </fixed-buttons>
    </q-page>
</template>

<script>
    import FixedButtons from './FixedButtons'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'

    export default {
        name: 'Achievements',
        components: {FixedButtons, QTooltip, QBtn},
        data () {
            return {}
        },
        methods: {
            edit (groupId) {
                this.$router.push({name: 'achievements-edit', params: {groupId}})
            },
            remove(groupId) {
                const all = this.$store.getters.achievement.filter(a => a.groupId === groupId)
                all.forEach(a => {
                    this.$store.dispatch('remove', {
                        what: 'achievement',
                        item: a
                    })
                })
                return all.filter((value, index) => index === all.lastIndexOf(value))
            }
        },
        mounted () {

        },
        computed: {
            achievements () {
                return this.$store.getters.achievement
            },
            groups () {
                const all = this.$store.getters.achievement.map(({groupId}) => groupId);
                return all.filter((value, index) => index === all.lastIndexOf(value))
            }
        },
    }
</script>